<template>
    <BaseModal :title="'Create Tag'" @close="closeModal">
        <template #modalContent>
            <div class="modal-content-wrapper">
                <div>
                    <h3 class="modal-heading text-xl font-bold text-white p-2">Add New Tag</h3>
                </div>
                <div class="flex items-start justify-start h-full w-full">
                    <form @submit.prevent="addTag" class="flex flex-col gap-6 mt-4 w-1/2">
                        <div>
                            <label for="tagName" class="text-lg text-gray-400">Tag Name</label>
                            <input id="tagName" v-model="newTag.name" type="text" placeholder="// e.g., Partners"
                                class="input-field text-lg p-2 w-full mt-1" required @input="validateTagName" />
                            <p v-if="tagNameError" class="text-red-500 text-[10px] mt-1">{{ tagNameError }}</p>
                        </div>
                        <div>
                            <label for="tagColor" class="text-lg text-gray-400">Tag Color</label>
                            <input id="tagColor" v-model="newTag.color" type="color"
                                class="input-field w-full h-12 mt-1" />
                        </div>
                        <div class="flex gap-2 w-full items-center justify-start">
                            <button type="submit" class="btn-create cursor-pointer" :disabled="!!tagNameError">
                                Add Tag
                            </button>
                            <button type="button" @click="closeModal" class="btn-cancel cursor-pointer">
                                Cancel
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </template>
    </BaseModal>
</template>

<script>
import BaseModal from "@/components/common/BaseModal.vue";

export default {
    name: "CreateTagModal",
    components: {
        BaseModal,
    },
    props: {
        tags: {
            type: Array,
            required: true,
        },
        closeModal: {
            type: Function,
            required: true,
        },
    },
    data() {
        return {
            newTag: {
                name: '',
                color: '#1f2937', 
            },
            tagNameError: '',
        };
    },
    methods: {
        validateTagName() {
            if (!this.newTag.name) {
                this.tagNameError = 'Tag name required';
            } else if (this.tags.includes(this.newTag.name)) {
                this.tagNameError = 'Tag name already exists';
            } else {
                this.tagNameError = '';
            }
        },
        addTag() {
            this.validateTagName();
            if (this.newTag.name && !this.tagNameError) {
                this.$emit('add-tag', {
                    name: this.newTag.name,
                    color: this.newTag.color,
                });
                this.resetForm();
                this.closeModal();
                this.$vs.notify({
                    title: 'Success!',
                    text: 'Tag added successfully',
                    color: 'success',
                });
            } else {
                this.$vs.notify({
                    title: 'Error!',
                    text: 'Please provide a valid, unique tag name',
                    color: 'danger',
                });
            }
        },
        resetForm() {
            this.newTag = { name: '', color: '#1f2937' };
            this.tagNameError = '';
        },
    },
};
</script>

<style scoped>
.modal-content-wrapper {
    padding: 16px;
}

.input-field {
    background: #1a1a1a;
    border: 1px solid #374151;
    color: #fff;
    transition: border-color 0.3s;
}

.input-field:focus {
    outline: none;
    border-color: #22c55e;
}

.btn-create,
.btn-cancel {
    padding: 8px 16px;
    font-size: 14px;
    font-weight: 600;
    transition: all 0.3s ease;
    line-height: 1.5;
    text-align: center;
}

.btn-create {
    background: #22c55e;
    color: #000;
}

.btn-create:hover {
    background: #16a34a;
}

.btn-create:disabled {
    background: #4b5563;
    cursor: not-allowed;
}

.btn-cancel {
    background: #1a1a1a;
    border: 1px solid #ff5555;
    color: #ff5555;
}

.btn-cancel:hover {
    background: #ff5555;
    color: #000;
}
</style>